// extracted by mini-css-extract-plugin
export default {"navigation-list":"Navigation_navigation-list__qwP3b","navigation":"Navigation_navigation__4AdlA","active":"Navigation_active__FP1Ee"};